<template>
  <v-card-text>
    <v-row no-gutters>
      <v-col cols="12" v-if="error" class="mt-2" sm="10" offset-sm="1">                    
        <v-alert dismissible v-if="error.code === 'auth/user-not-found'" class="warning" @dismissed="onDismissed">
          Die angegebene Mailadresse ist falsch oder nicht vergeben. Solltest Du Dich noch nicht registriert haben, kannst Du das <a href="/registrieren">HIER</a> machen.
        </v-alert>
        <v-alert dismissible v-if="error.code === 'auth/wrong-password'" class="warning" @dismissed="onDismissed">
          Das Passwort ist falsch.
        </v-alert>
        <v-alert dismissible v-if="(error.code !== 'auth/user-not-found') && (error.code !== 'auth/wrong-password')" class="warning" @dismissed="onDismissed">
          Bei der Anmeldung ist ein Fehler aufgetreten. Fehlercode: {{ error.code }} | {{ error.message }}
        </v-alert>
      </v-col>
      <v-col cols="12" sm="10" offset-sm="1">
        <v-text-field
        name="email"
        :loading="loading"
        :append-icon="checkMailValue.status === null ? '' : (checkMailValue.status ? 'check' : 'close')"
        @input="checkMail()"
        :hint="!checkMailValue.status ? checkMailValue.message : ''"
        persistent-hint
        label="Mail"
        id="email"
        v-model="email"
        type="email"
        outlined
        dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="10" offset-sm="1">
        <v-text-field
          outlined
          dense
          name="password"
          label="Passwort"
          id="password"
          v-model="password"
          type="password"
          required></v-text-field>
      </v-col>
      <v-col cols="12" sm="10" offset-sm="1">
        <v-btn block @click="onSignin()" class="primary" :disabled="!this.password || (this.checkMailValue.status === false) || (this.checkMailValue.status === null)" :loading="$vars.loading">
          Anmelden
        </v-btn>     
      </v-col>
      <v-col cols="12" class="mt-2" sm="10" offset-sm="1">
        <v-btn class="caption" block text @click="goToRegistrierung()">
          Registrieren
        </v-btn>
        <v-btn class="caption" block text @click="onDismissed()" to="/passwortvergessen">
          Passwort vergessen?
        </v-btn>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        email: '',
        password: '',
        checkMailValue: { status: null },
        loading: false
      }
    },
    computed: mapState({
      user: state => state.user.user,
      error: state => state.user.error
    }),
    watch: {
      user (value) {
        if (value !== null && value !== undefined) {
          if (this.$route.query !== '') {
            this.$router.push(this.$route.query.link)
          } else {
            this.$router.push('/')
          }
        }
      }
    },
    methods: {
      goToRegistrierung () {
        this.onDismissed()
        this.$router.push('/registrieren')
      },
      checkMail () {
        this.loading = true
        this.checkMailValue = { status: null }
        var functions = this.$firebase.functions()
        if (this.email) {
          functions.httpsCallable('userLoginAllowed')({ email: this.email.toLowerCase(), sub: this.$vars.verbindung })
            .then(({ data }) => {
              this.checkMailValue = data
              this.loading = false
            })
            .catch(error => {
              this.error = error
              this.loading = false
            })
        } else {
          this.checkMailValue = { status: null }
          this.loading = false
        }
      },
      onSignin () {
        this.test = true
        this.$store.dispatch('user/signUserIn', {email: this.email, password: this.password})
        this.$router.push('/')
      },
      onDismissed () {
        this.$store.dispatch('user/clearError')
      }
    }
  }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// SigninForm.vue?2eb66677